import RootState from '@/store/root_state';
import { ActionTree, Commit, Dispatch } from 'vuex';
import { HelperAppState } from './state';

const actions: ActionTree<HelperAppState, RootState> = {
  async SET_LOADING_APP_ACTION({ commit }, value: boolean): Promise<void> {
    commit('SET_LOADING_APP_MUTATION', value);
  },
};

export default actions;
